import ModalDialog from './modal-dialog';
export default ModalDialog;
